import { SignIn, useUser } from "@clerk/react"
import { dark } from "@clerk/themes"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect, useState } from "react"
import { useTheme } from "@/components/global/theme/theme-provider"
import { checkAdminAccess } from "@/integrations/clerk/auth"

export const Route = createFileRoute("/login")({
	component: LoginPage,
})

function LoginPage() {
	const { theme } = useTheme()
	const { user, isLoaded } = useUser()
	const navigate = useNavigate()
	const [isDark, setIsDark] = useState(false)

	useEffect(() => {
		const darkMode =
			theme === "dark" ||
			(theme === "system" &&
				window.matchMedia("(prefers-color-scheme: dark)").matches)
		setIsDark(darkMode)
	}, [theme])

	useEffect(() => {
		if (isLoaded && user) {
			if (checkAdminAccess(user)) {
				navigate({ to: "/" })
			} else {
				navigate({ to: "/unauthorized" })
			}
		}
	}, [isLoaded, user, navigate])

	return (
		<div className="flex min-h-screen items-center justify-center bg-background">
			<div className="w-full max-w-md space-y-8 px-4">
				<div className="text-center">
					<h1 className="text-4xl font-bold tracking-tight">CardNexus Admin</h1>
					<p className="mt-2 text-muted-foreground">
						Sign in to access the admin dashboard
					</p>
				</div>

				<SignIn
					signUpUrl="/sign-up"
					forceRedirectUrl="/"
					appearance={{
						theme: isDark ? dark : undefined,
						elements: {
							card: "shadow-lg",
							formButtonPrimary:
								"bg-primary text-primary-foreground hover:bg-primary/90",
						},
					}}
				/>
			</div>
		</div>
	)
}
